// ============================================================
// Cierre de sesión por inactividad (ASVS V3.3.2)
// ============================================================
//
// El backend responde 401 con este code tras 15 min sin actividad y YA ha
// borrado las tres cookies, refresh incluida: intentar el refresh solo da otro
// 401 y acababa en un salto al login mudo, que la QA vivió como «la sesión se
// cae». Lo usan las dos vías que ven ese 401: `apiFetch` (rutas normales) y el
// `/api/auth/me` de `AuthContext`, que es donde cae la mayoría. Vive en un módulo
// propio, y no en apiFetch, porque muchos tests mockean apiFetch entero.

import { rememberLoginReturn } from '../lib/loginReturn';
import { safeStorage } from '../lib/safeStorage';

export const SESSION_IDLE_TIMEOUT = 'SESSION_IDLE_TIMEOUT';

// Con la sesión cerrada, todas las peticiones en vuelo vuelven con el mismo 401:
// solo la primera limpia y redirige; el resto se limita a rechazar.
let idleLogoutStarted = false;

function isOnLoginPage(): boolean {
  const pathname = (window.location.pathname || '').replace(/\/+$/, '');
  return pathname === `${import.meta.env.BASE_URL}login`;
}

/**
 * Limpia el estado local y manda al login con `?reason=idle`. Devuelve `true` si
 * hay (o ya había) una redirección en marcha; `false` si ya se está en el login,
 * donde redirigir otra vez sería un bucle y el aviso, si tocaba, ya está pintado.
 */
export function handleIdleTimeout(): boolean {
  if (idleLogoutStarted) return true;
  // A dónde volver tras entrar (DT-06). Se lee la persona ANTES de limpiar su estado.
  let userId: string | null = null;
  try { userId = JSON.parse(safeStorage.getItem('verix_user') || 'null')?.id ?? null; } catch { /* JSON corrupto */ }
  // Mismo estado local que limpia `logout()` de AuthContext. No hace falta
  // llamar a /api/auth/logout: las cookies ya las borró el servidor.
  try { sessionStorage.removeItem('verix_csrf'); } catch { /* storage bloqueado */ }
  try {
    localStorage.removeItem('verix_user');
    localStorage.removeItem('verix_company');
  } catch { /* storage bloqueado */ }
  // Sin marcar el flag: tras entrar, el login navega por SPA (sin recargar el
  // módulo) y un cierre por inactividad posterior debe volver a redirigir.
  if (isOnLoginPage()) return false;
  rememberLoginReturn({ userId });
  idleLogoutStarted = true;
  window.location.href = `${import.meta.env.BASE_URL}login?reason=idle`;
  return true;
}
